import React from "react";
import { Share2, Link2, MessageCircle, Facebook, Twitter } from "lucide-react";
import { toast } from "../hooks/use-toast";

export const ShareButtons = ({ url, text }) => {
  const enc = encodeURIComponent;
  const links = [
    { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, bg: "#25D366", href: `https://wa.me/?text=${enc(`${text} ${url}`)}` },
    { id: "facebook", label: "Facebook", icon: Facebook, bg: "#1877F2", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { id: "x", label: "X", icon: Twitter, bg: "#0f1419", href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}` },
  ];
  const copy = () => { navigator.clipboard?.writeText(url); toast({ title: "Link copied" }); };
  const native = async () => {
    try { await navigator.share({ title: text, text, url }); } catch { /* cancelled */ }
  };
  const btn = "inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium text-white transition-transform hover:-translate-y-0.5";
  return (
    <div className="mt-6" data-testid="share-buttons">
      <p className="text-sm font-medium text-[#16243b] mb-2">Share this moment</p>
      <div className="flex flex-wrap gap-2">
        {typeof navigator !== "undefined" && navigator.share && (
          <button onClick={native} data-testid="share-native" className={btn} style={{ background: "#2ec9c9" }}><Share2 size={15} /> Share</button>
        )}
        {links.map((l) => (
          <a key={l.id} href={l.href} target="_blank" rel="noreferrer" data-testid={`share-${l.id}`} className={btn} style={{ background: l.bg }}>
            <l.icon size={15} /> {l.label}
          </a>
        ))}
        <button onClick={copy} data-testid="share-copy" className={`${btn} !text-[#16243b] bg-white border border-gray-200`}><Link2 size={15} /> Copy link</button>
      </div>
    </div>
  );
};
